import IconPlayVideo from '../asserts/icon/play-video.png'

import ImageHomeFooter from '../asserts/home/footer.png'
import ImageHomeSwiper1 from '../asserts/home/swiper1.png'
import ImageHomeSwiper2 from '../asserts/home/swiper2.png'
import ImageHomeSwiper3 from '../asserts/home/swiper3.png'

const HOMECONFIG = {
  swiper: [
    ImageHomeSwiper1,
    ImageHomeSwiper2,
    ImageHomeSwiper3
  ],
  video: {
    button: { en: 'Promotional Video', cn: '宣传片' },
    icon: IconPlayVideo,
    link: 'https://v.qq.com/x/page/l3254dggujg.html'
  },
  footer: {
    background: ImageHomeFooter
  }
}

export default HOMECONFIG